import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Redirect } from 'react-router'

import validateOtp from '../../../../services/validation/OTP'
import { doVerifyOtp } from '../../../../controllers/Login.js'
import { VERIFY_OTP } from '../../../../services/data/loginSteps.json'
import { postRequestOtp } from '../../../../services/api/requests/Login'
import {
  setGACustomPageView,
  setGACustomEvent,
} from '../../../../services/analytics/google-analytics'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'

// simplified imports
import OtpForm from '../../../../components/ui/SimplifiedLogin/OtpForm/OtpForm'
import { Layout as MainLayout } from '../../../../components/ui/SimplifiedLogin'
import {
  Title,
  Description,
  FormWrapper,
  ContentContainer,
} from '../../../simplified.login/components/MainView/MainView.style'
import { REGISTRATION_STEPS } from '../../../../services/hooks/useRegistrationBanners'

const MainView = ({
  loginRequestId,
  loginStep,
  authRequestData,
  firebaseMessagingToken,
  replace,
  setPrimaryInfo,
  setPreferenceIds,
  setAccessToken,
  saveAccessToken,
  setLoyaltyPoints,
  setFirstSpinModalOpen,
  setStep,
  redirectAfterAuth,
  doSubscribeToFirebaseMessaging,
  setAuthRequestData,
  setLoginStep,
  setLoginRequestId,
  location = {},
  setAccountStatus,
}) => {
  const [smsMode, setSMSMode] = React.useState(false)

  React.useEffect(() => {
    setGACustomPageView({
      page: location.pathname,
      title: 'Login - OTP Verification',
    })
  }, [location.pathname])

  const resend = async ({ toMobile, setLoading, setError }) => {
    const { mobile } = authRequestData

    setLoading(true)
    setError(null)
    setSMSMode(toMobile)
    setGACustomEvent('button_cta', {
      screen_name: 'Login - OTP Verification',
      button_name: `Resend - Receive via ${toMobile ? 'SMS' : 'Email'}`,
    })

    try {
      const response = await postRequestOtp({ mobile, toMobile })
      const { requestId } = response.data
      setLoginRequestId(requestId)
    } catch (error) {
      const {
        data = {},
        // , status
      } = error.response || {}
      const { message = 'Network Error' } = data || {}
      setError(message)
    }
    setLoading(false)
  }

  const redirectToThirdParty = async (redirectUri, code) => {
    if (typeof window !== undefined && window.location && redirectUri) {
      window.location.href = redirectUri + (code ? `?code=${code}` : '')
    }
  }

  const { maskedEmail, mobile } = authRequestData || {}
  const maskedMobile = mobile ? mobile.slice(-4) : ''

  if (loginStep !== VERIFY_OTP) {
    return <Redirect to={`/login${location.search || ''}`} />
  }

  return (
    <MainLayout registrationStep={REGISTRATION_STEPS.LOGIN_OTP}>
      <ContentContainer minHeight={420}>
        <div>
          <Title>We want to know it’s really you.</Title>
          <Description>
            Enter the code we sent via&nbsp;
            {!smsMode ? (
              <>
                email to &nbsp;<span>{maskedEmail}</span>
              </>
            ) : (
              <>
                SMS to mobile number ending in &nbsp;<span>{maskedMobile}</span>
              </>
            )}
          </Description>
          <FormWrapper>
            <AccessibleForm
              enableReinitialize
              initialValues={{}}
              validate={validateOtp}
              onSubmit={doVerifyOtp({
                replace,
                setPrimaryInfo,
                setAccessToken,
                saveAccessToken,
                setLoyaltyPoints,
                setPreferenceIds,
                setStep,
                redirectAfterAuth,
                firebaseMessagingToken,
                doSubscribeToFirebaseMessaging,
                setAuthRequestData,
                setLoginStep,
                loginRequestId,
                redirectToThirdParty,
                searchString: location.search,
                setFirstSpinModalOpen,
                setAccountStatus,
              })}
              method="post"
              action="/a/otp/submit"
              componentProps={{ resend }}
              component={OtpForm}
            />
          </FormWrapper>
        </div>
        <div />
      </ContentContainer>
    </MainLayout>
  )
}

MainView.defaultProps = {
  maskedData: {},
  // forgotStep: OTP,
}

MainView.propTypes = {
  maskedData: PropTypes.object,
  forgotStep: PropTypes.number,
}

export default MainView
